module.exports = __webpack_public_path__ + "static/img/case_detail_03_2.9e6031e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_2.png
// module id = Zw2c
// module chunks = 34